import { useAppDispatch } from '@/state'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import routes from '@/routes'
import { GlobalUIActions } from '@/state/ui/global/slices/index.slices'

const useUIFeedback = () => {
  const dispatch = useAppDispatch()

  const { t } = useTranslation()

  const navigate = useNavigate()

  const handleAbortCreateBonus = (anchorPosition: {
    top: number
    left: number
  }) => {
    dispatch(
      GlobalUIActions.setPopoverConfirmAction({
        action: t('labels.abort').toLocaleLowerCase(),
        anchorPosition,
        open: true,
        type: t('bonus').toLowerCase(),
        handler: () => navigate(`${routes.bonus.INDEX}`),
      }),
    )
  }

  return {
    handleAbortCreateBonus,
  }
}

export default useUIFeedback
